import RoundImage from 'components/atoms/RoundImage';
import Button from 'components/atoms/teachers/Button';
import ModalTextContainer from 'components/molecules/teachers/ModalTextContainer';
import { localStorage as localStorageConstants } from 'constants/index';
import * as qs from 'qs';
import React from 'react';
import { postStartConversation } from 'reducers/conversation';
import styled from '@emotion/styled';
import getAuthToken from 'utils/getAuthToken';
import getMe from 'utils/getMe';
import getPartner from 'utils/getPartner';
import isWebView from 'utils/isWebView';
import resolvePath from 'utils/resolvePath';
import { colors } from 'constants/colors';
import getPreferredName from 'utils/getPreferredName';
export default (props) => {
    const { conversation, myId, path, close } = props;
    const partner = getPartner(conversation, myId);
    const me = getMe(conversation, myId);
    const authToken = getAuthToken();
    const onClick = () => {
        if (!me || !partner)
            return;
        close();
        try {
            if (authToken) {
                postStartConversation(authToken, conversation.id);
            }
        }
        catch (error) {
            // nothing to do
        }
        if (!isWebView()) {
            return;
        }
        const partnerName = getPreferredName(partner.name, partner.preferred_name, partner.type);
        const myName = getPreferredName(me.name, me.preferred_name, me.type);
        const params = {
            end_url: `/teachers/conversations/${conversation.id}/end`,
            partner_name: partnerName,
            partner_photo_url: partner ? partner.picture_url : '',
            redirect_url: `/teachers/conversations/${conversation.id}/evaluate`,
            channel_id: conversation.channel_id,
            user_type: 'Teacher',
            user_id: me ? me.id : 0,
            user_name: myName,
            user_photo: me ? me.picture_url : '',
            partner_id: partner ? partner.id : 0,
            ws_token: localStorage.getItem(localStorageConstants.WEB_SOCKET_TOKEN_KEY) || '',
        };
        window.location.href = `sailapp://call?${qs.stringify(params)}`;
    };
    return (React.createElement(Container, null,
        React.createElement(ModalTextContainer, { heading: '会話時刻になりました', text: 'さぁ、会話を始めましょう！' }),
        React.createElement(RoundImage, { src: partner ? partner.picture_url : '', size: 200, marginBottom: 24, code: partner ? partner.country_code : '' }),
        React.createElement(Name, null, partner ? partner.name : ''),
        React.createElement(ButtonContainer, null,
            React.createElement(Button, { type: "green", text: "\u4F1A\u8A71\u3059\u308B", link: isWebView() ? '' : resolvePath.page('teachers', path), onClick: onClick })),
        React.createElement(CloseButton, { onClick: close }, "\u9589\u3058\u308B")));
};
const Container = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 40px;
  width: 100%;

  @media (orientation: landscape) {
    justify-content: flex-start;
  }
`;
const ButtonContainer = styled.div `
  display: flex;
  justify-content: space-evenly;
  padding-bottom: 40px;

  & a {
    padding: 0 1em;
  }
`;
const Name = styled.div `
  margin-bottom: 16px;
  font-size: 40px;
  font-weight: 500;
  letter-spacing: 0px;
  text-align: center;
  color: ${colors[405766]};

  &::after {
    margin-left: 8px;
    font-size: 32px;
    content: 'さん';
  }
`;
const CloseButton = styled.button `
  background-color: transparent;
  color: ${colors.blue2};
  cursor: pointer;
  font-size: 28px;
  margin: 16px auto 0px;
  padding-bottom: 40px;
  text-align: center;
  text-decoration: underline;
`;
